window.addEventListener("DOMContentLoaded", () => {
    searchTypeSetting();
    searchFieldSetting();
});

const searchTypeSetting = () => {
    //  パラメーターのタイプを取得する
    const parameterType = new URLSearchParams(location.search).getAll("type");

    // タイトル箇所のタグ取得
    const templateSearchTitle = document.querySelector(
        ".template-search_title"
    );

    // 商品・記事の場合はタイトル・タブの表示を変更
    if (parameterType == "product") {
        // 二つ目のタブを選択された状態にする
        const productTab = document.getElementById("search_tab02");
        productTab.checked = true;

        // 検索結果のタイトル先頭に商品を追加
        templateSearchTitle.insertAdjacentText("afterbegin", "商品");
    } else if (parameterType == "article") {
        const articleTab = document.getElementById("search_tab03");
        articleTab.checked = true;
        templateSearchTitle.insertAdjacentText("afterbegin", "記事");
    }
};

const searchFieldSetting = () => {
    // 検索フィールドの取得
    const searchFields = document.getElementsByName("q");
    // パラメーターqの取得
    const parameterQ = new URLSearchParams(location.search).getAll("q");
    searchFields.forEach((searchField) => {
        // 書き換え
        searchField.value = parameterQ;
    });
};
